import React, { Component } from 'react';
import Barcode from 'react-barcode';
import QRCode from 'qrcode.react';
import { Modal, Button } from 'antd';

import './styles.scss';

export default class BarcodeT extends Component {
    state = { visible: false };

    componentDidMount() {}

    render() {
        return (
            <Modal
                title={this.props.testName}
                open={this.props.barcodeVisible}
                onCancel={() => this.props.closeHandler()}
                footer={
                    <div className="footer">
                        <div className="buttons">
                            <Button type="primary" onClick={() => this.props.closeHandler()}>Close</Button>
                        </div>
                    </div>
                }
                width={950}
            >
                <React.Fragment>
                    <div className="flex-container">
                        <div className="barcode-container">
                            <Barcode value={this.props.uuid} />
                        </div>
                    </div>
                    <div className="flex-container">
                        <QRCode value={this.props.uuid} className="qr-code" />
                    </div>
                </React.Fragment>
            </Modal>
        );
    }
}
